<pbc-sorter [config]="FeldUnterkategoriesSorterConfig" [sorter]="feldUnterkategories.sorter$ | async" (sorterChange)="feldUnterkategories.sorter$.next($event)"></pbc-sorter>
